<template>
	<div class="flow-side-bar height-100">
		<div class="side-bar-drawer-wrapper height-100">
			<perfect-scrollbar class="height-100">
				<div class="block-settings height-100">
					<BlockEditorDispatcher v-if="nodeId" :key="nodeId" :nodeID="nodeId" />
					<TriggerEditor v-else-if="isTriggerEditor" />
				</div>
			</perfect-scrollbar>
		</div>
		<div class="expandable-sliding-drawer height-100" :class="[drawerDir]">
			<SideBarDrawer :drawerDir="drawerDir" />
		</div>
	</div>
</template>

<script>
import BlockEditorDispatcher from '@/components/BlockEditor/BlockEditorDispatcher.vue';
import TriggerEditor from '@/components/BlockEditor/TriggerEditor/TriggerEditor.vue';
import { SideBarDrawer, SideBarDrawerDirection, isValidSideBarDrawerDirection } from '@/components/SideBarDrawer';
import { TRIGGER_EDITOR_ROUTE_NAME } from '@/router/router.const.js';
export default {
	name: 'NodeEditor',
	props: {
		drawerDir: { type: String, default: SideBarDrawerDirection.Left, validator: isValidSideBarDrawerDirection },
	},
	components: {
		SideBarDrawer,
		TriggerEditor,
		BlockEditorDispatcher,
	},
	computed: {
		nodeId() {
			return this.$route.params.nodeID;
		},
		isTriggerEditor() {
			return this.$route.name === TRIGGER_EDITOR_ROUTE_NAME;
		},
	},
};
</script>

<style scoped lang="scss">
.flow-side-bar {
	position: relative;

	.side-bar-drawer-wrapper {
		border-radius: 0 !important;
		margin: 0 !important;
		box-shadow: none !important;
		overflow: auto;
		background: #fcfcfd !important;
		z-index: 0;

		.block-settings {
			position: relative;
			overflow: hidden;

			::v-deep {
				.v-input__append-inner {
					.v-icon.fa-caret-down {
						font-size: 14px;
					}
				}
			}
		}
	}
	.expandable-sliding-drawer {
		position: absolute;
		top: 0;
		height: 100%;
		z-index: -1;
		&.left {
			left: 0;
		}
		&.right {
			right: 0;
			transform: translateX(100%);
		}
	}
}
</style>
